<template>
  <question-card
    class="occupancy-type-step"
    hide-button
  >
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div>
      <answer-icon-block class="type-icons">
        <answer-icon
          @click="answer(answers.primaryHome)"
          image="primary_home.svg"
          :checked="questionnaireLead.OccupancyType === answers.primaryHome"
        >
          {{UIComponentData.Choice1.Translations[questionnaireLead.Language]}}
        </answer-icon>
        <answer-icon
          @click="answer(answers.secondHome)"
          image="second_home.svg"
          :checked="questionnaireLead.OccupancyType === answers.secondHome"
        >
          {{UIComponentData.Choice2.Translations[questionnaireLead.Language]}}
        </answer-icon>
        <answer-icon
          @click="answer(answers.rentalProperty)"
          image="rent_property.svg"
          :checked="questionnaireLead.OccupancyType === answers.rentalProperty"
        >
          {{UIComponentData.Choice3.Translations[questionnaireLead.Language]}}
        </answer-icon>
      </answer-icon-block>
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ANSWERS } from '@/utils/constants/common';
import QuestionCard from '@/components/QuestionCard.vue';
import AnswerIcon from '@/components/AnswerIcon.vue';
import AnswerIconBlock from '@/components/AnswerIconBlock.vue';

export default {
  name: 'occupancy-type-step',
  components: {
    QuestionCard,
    AnswerIcon,
    AnswerIconBlock,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  data: () => ({
    answers: ANSWERS.occupancyTypes,
  }),
  methods: {
    ...mapActions(['mutateLead']),
    async answer(value) {
      this.questionnaireLead.OccupancyType = value;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
    computed: {
    ...mapGetters(['questionnaireLead']),
    }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';
@import '~@/styles/variables';

.occupancy-type-step {
    .answer-icon {
    flex: 1 1 150px;
    padding: 0;

    &:not(:last-child) {
      .answer-icon__image-wrapper {
        position: relative;

        &::after {
          content: none;
        }
      }
    }
    &::after {
      display: none;
    }

    &:nth-child(1) {
      border-right: $quest-icon-splitter-border;
      @media (max-width: 379px) {
        border-bottom: $quest-icon-splitter-border;
        border-right: none;
      }
      padding-bottom: 30px;
    }

    &:nth-child(2) {
      padding-bottom: 30px;
    }

    &:nth-child(3) {
      padding-top: 30px;
      border-top: $quest-icon-splitter-border;
      @media (min-width: 530px) {
        border-top: none;
        border-left: $quest-icon-splitter-border;
      }
    }
  }

  .answer-icon {
    &:nth-child(-n + 3) {
      padding: 20px 0;
    }
  }


}

@media (min-width: 1281px) {
    .type-icons {
      flex-wrap: nowrap;
    }
}

</style>
